import { render, staticRenderFns } from "./T1AutoResearcherBox.vue?vue&type=template&id=024f6e18&scoped=true"
import script from "./T1AutoResearcherBox.vue?vue&type=script&lang=js"
export * from "./T1AutoResearcherBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f6e18",
  null
  
)

export default component.exports